import axios from 'axios'
import utils from '@/utils'
import router from '@/router'
import {Message} from 'element-ui'
import {Toast} from 'vant'

let closed = true

axios.defaults.timeout = 150000; //响应时间

axios.defaults.baseURL = ''; //配置接口地址

axios.defaults.withCredentials = true;// 验证码验证

//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
  if (config.method == 'get') {
    config.data = true
  }
  config.headers["Request-Login-Type"] = "PC"
  // config.headers["Request-User-Type"] = "20"
  config.headers["Request-User-Type"] = "30"
  return config;
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error);
});

function showMessage(message, type, duration = 3 * 1000) {
  if (window.innerWidth <= 768) {//移动端显示
    if (type && type === 'success') {
      Toast.success(message)
    } else {
      Toast.fail(message);
    }
  } else {
    if (closed) {
      closed = false
      return Message({
        message: message,
        type: type,
        duration: duration,
        onClose: () => {
          closed = true
        }
      })
    }
  }
}

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    return res;
  }, (error) => {
    if (error.response) {
      console.log(error.response)
      switch (error.response.status) {
        case 401:
          localStorage.clear();
          router.push({path: '/'});
          return Promise.resolve({code: 500, msg: '无response！'});
        case 400:
        case 404:
          showMessage('404:您访问的页面不存在', 'error')
        case 422:
          showMessage('422:' + error.response.data.msg, 'error')
          return Promise.resolve(error.response);
        case 500:
          showMessage('500:服务器错误', 'error')
        case 502:
          showMessage('502:无法连接到服务器', 'error')
        case 504:
          showMessage('504:网页请求超时', 'error')
      }
    }
  }
);

function setUserParams(params) {
  let user = localStorage.getItem('SYSUSER');
  if (typeof (params) == 'object' && user) {
    user = JSON.parse(user);
    if (!params.storeId) {
      params.storeId = user.storeId;
    }
    if (!params.merchantId) {
      params.merchantId = user.merchantId;
    }
    if (!params.agentId) {
      params.agentId = user.agentId;
    }
    // params.agentId = user.agentId;
    // params.merchantId = user.merchantId;
    // params.storeId = user.storeId;
    return params;
  } else {
    return params;
  }
}

//序列化加密添加token
function serializeParam(data) {
  let key = utils.getSessionID();
  if (!key) {
    return data;
  }
  let params = null;
  if (typeof (data) == 'string')
    params = utils.stringToJSON(data);
  else
    params = utils.deepClone(data);
  let par = {};
  Object.keys(params).map(key => {
    if (params[key] != null && params[key] != undefined)
      par[key] = params[key]
  });
  params = par;
  //转成字符
  let paramsStr = utils.JSONToString(utils.sortASCII(params));
  paramsStr += '&key=' + key;
  //md5加密 并转成大写
  let md5Str = utils.md5(utils.stringToBytes(paramsStr)).toUpperCase();
  params.sign = md5Str;
  if (typeof (data) == 'string') {
    return utils.JSONToString(params);
  }
  return params;
}

//返回一个Promise(发送post请求)
function fetchPost(url, params = {}, headers = {}, tip) {
  params = serializeParam(setUserParams(params));
  // headers = Object.assign({"Request-User-Type":"PC"},headers)
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject, tip);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

//返回一个Promise(发送put请求)
function fetchPut(url, params = {}, headers, tip) {
  return new Promise((resolve, reject) => {
    axios.put(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject, tip);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

//返回一个Promise(发送Delete请求)
function fetchDelete(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {params: params}, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}


//发送get请求
function fetchGet(url, params = {}, headers = {}) {
  let searchParams = {};
  if (url.split('?').length > 1) {
    searchParams = utils.stringToJSON(url.split('?')[1]);
    url = url.split('?')[0];
  }
  params = {...searchParams, ...params};
  params = serializeParam(setUserParams(params));
  // headers = Object.assign({"Request-User-Type":"PC"},headers)
  return new Promise((resolve, reject) => {
    axios.get(url, {params: params}, {headers: headers}).then(response => {
      successDataReturn(response, resolve, reject);
    }, err => {
      reject(err)
    })
      .catch((error) => {
        reject(error)
      })
  })
}

function fetchPostBlob(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'blob'},)
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

//流转化为图片src
function fetchPostStream(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'arraybuffer'},)
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

//返回一个Promise(发送post请求)
function fetchPostInUpload(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers})
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function fetchPostImportExport(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'blob'},)
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function successDataReturn(response, resolve, reject, tip) {
  if (response && response.status == 200) {
    if (response.data.code == 200) {
      resolve(response.data);
      if (tip != null) {
        showMessage(tip, 'success', 1000)
      }
    } else {
      showMessage(response.data.code + ':' + response.data.msg || response.data.code + ':' + response.data.errorMsg || '请求失败', 'error', 2000)
      // Message({
      //   message:response.data.code + response.data.msg || response.data.code + response.data.errorMsg || '请求失败',
      //   type: 'error',
      //   duration:1000
      // })
      if (response.data.code == '10031009') {//未登录不允许访问
        localStorage.clear();
        router.push({path: '/'});
      }
      resolve(response.data);
    }
  } else if (response && response.status != 200 && response.data) {
    response.data.msg = (response.data && (response.data.msg || response.data.errorMsg)) || '请求失败';
    response.data.code = response.status;
    resolve(response.data);
  } else {
    reject({code: 500, msg: '无response！'});
  }
}

function fetchPostGoodsExport(url, params = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers},)
      .then(response => {
        successDataReturn(response, resolve, reject);
      }, err => {
        console.log(err)
        reject(err);
      })
      .catch((error) => {
        console.log(err)
        reject(error)
      })
  })
}

function PostBlob(url, params = {}, headers) {
  params = serializeParam(setUserParams(params));
  return new Promise((resolve, reject) => {
    axios.post(url, params, {headers: headers, responseType: 'arraybuffer'})
        .then(response => {
          successBlobDataReturn(response, resolve, reject);
        }, err => {
          console.log(err)
          reject(err);
        })
        .catch((error) => {
          console.log(err)
          reject(error)
        })
  })
}

function successBlobDataReturn(response, resolve, reject) {
  if (response && response.status == 200) {
    resolve(response);
  } else if (response && response.status != 200 && response.data) {
    response.data.msg = (response.data && (response.data.msg || response.data.errorMsg)) || '请求失败';
    response.data.code = response.status;
    resolve(response.data);
  } else {
    reject({code: 500, msg: '无response！'});
  }
}

export default {
  fetchPost,
  fetchGet,
  fetchPut,
  fetchDelete,
  fetchPostBlob,
  fetchPostStream,
  fetchPostInUpload,
  fetchPostImportExport,
  fetchPostGoodsExport,
  PostBlob
}



// WEBPACK FOOTER //
// ./src/services/axios.js